import React from 'react';
import { Menu, Icon, Dropdown, Tooltip } from 'antd';
import { Link, withRouter } from 'react-router-dom';
import { gql, graphql } from 'react-apollo';
import { FormattedMessage } from 'react-intl';

const getUserFullName = (user) => {
  let fullName = [];
  if (user.firstName) {
    fullName.push(user.firstName);
  }
  if (user.lastName) {
    fullName.push(user.lastName);
  }
  return fullName.join(' ')
}

const getUserInfoStr = (user) => {
  if (!user) {
    return 'Offline'
  }
  let fullName = getUserFullName(user)
  return fullName ? fullName : user.username;
}

class UserMenu extends React.Component {
  state = {
    usernameFromRouter: null
  }

  componentDidMount() {
    // fix for the graphql infinity loading after it has redirected from the login page
    // https://github.com/apollographql/apollo-client/issues/2687
    // just invoke the username not from a graphql but from the router
    if(this.props.location && this.props.location.state && this.props.location.state.username)
      this.setState({usernameFromRouter: this.props.location.state.username})
  }
  
  render() {
    let { loading, user } = this.props.data;
    let userTitle = getUserInfoStr(user);
    const {location} = this.props;
    const {usernameFromRouter} = this.state
    if (loading) {
      if (usernameFromRouter) {
        // when graphql stucked
        userTitle = usernameFromRouter
        user = {username: usernameFromRouter}
      } else return <div className="loading"></div>
    } 
    const menu = (
      <Menu selectedKeys={[location.pathname]} className='user-menu'>
        <Menu.Item key="/dashboard/analytics">
          <Link to="/dashboard/analytics">
            <Icon type='area-chart' />
            <FormattedMessage id="user-menu.dashboard" defaultMessage="Dashboard"/>
          </Link>
        </Menu.Item>
        <Menu.Item key="/dashboard/profile">
          <Link to="/dashboard/profile">
            <Icon type='user' />
            <FormattedMessage id="user-menu.profile" defaultMessage="Profile"/>
          </Link>
        </Menu.Item>
        <Menu.Item key="/dashboard/billing">
          <Link to="/dashboard/billing">
            <Icon type="wallet" />
            <FormattedMessage id="user-menu.billing" defaultMessage="Billing"/>
          </Link>
        </Menu.Item>
        <Menu.Item key="/dashboard/payments">
          <Link to="/dashboard/payments">
            <Icon type="calculator" />
            <FormattedMessage id="user-menu.payments" defaultMessage="Payments" />
          </Link>
        </Menu.Item>
        <Menu.Item key="/integration">
          <Link to="/dashboard/integration">
            <Icon type="api" />
            <FormattedMessage id="user-menu.integration" defaultMessage="Integration"/>
          </Link>
        </Menu.Item>
        <Menu.Divider />
        <Menu.Item key="/logout">
          <Link to="/logout">
            <Icon type="logout" />
            <FormattedMessage id="user-menu.logout" defaultMessage="Logout"/>
          </Link>
        </Menu.Item>
      </Menu>
    );
    return (
      <Tooltip placement='left' title={userTitle}>
        <Dropdown overlay={menu} trigger={['click']}>
          <a className='user-menu-dropdown ant-dropdown-link' href='/user-menu'
            style={{ float: 'right', margin: '0 10px',
              textDecoration: 'none', color: '#000' }}>
            <span className='username'>{user && user.username}</span>
            <Icon type="caret-down" />
          </a>
        </Dropdown>
      </Tooltip>
    )
  }
}

const USER_QUERY = gql`
  query {
    user {
      id,
      username,
      firstName,
      lastName
    }
  }
`;

const withUser = graphql(USER_QUERY, {
  options: () => ({ variables: {}}),
});

export default withRouter(withUser(UserMenu));


// WEBPACK FOOTER //
// ./src/components/dashboard/layout/user-menu.js